import moment from "moment";

let date = new Date();
date.getHours(10);
date.getMinutes(0);
date.getSeconds(0);

export const ALERT_ACTION = "ALERT_ACTION";
export const CREATE_ALERT_ACTION = "CREATE_ALERT_ACTION"; 
export const DELETE_ALERT_ACTION = "DELETE_ALERT_ACTION";

export const DEFAULT_PARAMETERS = {
  defaultWakeupTime: moment(new Date()).set({
    hour: parseInt(10),
    minute: parseInt(0),
  }).toDate(),
  defaultWakeupNotifyTime: moment(new Date()).set({
    hour: parseInt(12),
    minute: parseInt(0),
  }).toDate(),
  defaultFootstepsEndTime: moment(new Date()).set({
    hour: parseInt(6),
    minute: parseInt(0),
  }).toDate(),
  defaultFootstepsNotifyTime: moment(new Date()).set({
    hour: parseInt(20),
    minute: parseInt(0),
  }).toDate(),
  stepCount: 3000,

};

export const PARAMETER_ID = {
  FIRST_PHONE_USAGE: "1",
  FOOTSTEPS: "4",
};
